module.exports = __webpack_public_path__ + "static/Resources-aff7afcf59020dce7a871ecc3611baf0.png";